<template>
    <v-main  >
        <v-container
            class="fill-height"
            fluid
            dark
            :style="{'background-image': 'url(' + require('../../assets/bak3.jpg') + ')'}"
            style="background-size: cover"
        >
            <v-row
                align="center"
                justify="center"
            >
                <v-col
                    cols="12"
                    sm="8"
                    md="5"
                >
                    <v-col cols="12" class="text-center">
                        <img alt="Login" src="../../assets/login_img.png" style="width: 150px;">
                    </v-col>
                    <v-card 
                        class="elevation-12"
                        v-if="fetching=='fetching'"
                    >
                        <v-card-text>
                            <v-col cols="12" class="text-center">
                                <v-card
                                    color="primary"
                                    dark
                                >
                                    <v-card-text
                                        class="display-1"
                                    >
                                        Validando token de seguridad
                                        <v-progress-linear
                                            indeterminate
                                            color="white"
                                            class="mb-0"
                                        ></v-progress-linear>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-card-text>
                    </v-card>
                    <v-card 
                        class="elevation-12"
                        v-else-if="fetching=='error'"
                    >
                        <v-card-text>
                             <v-col cols="12" class="text-center">
                                <v-alert type="error">
                                    Lo sentimos el token enviado no le pertenece, o ya fue usado
                                </v-alert>
                             </v-col>
                        </v-card-text>
                    </v-card>
                    <v-card 
                        class="elevation-12"
                        v-else
                    >
                        <v-card-text>
                            <v-col cols="12" class="text-center">Bienvenido usuario {{user}}, Ingrese su nueva contraseña</v-col>
                            <v-form ref="form_reset_password">
                                <v-text-field
                                    v-model="password"
                                    label="Ingrese su nueva contraseña"
                                    prepend-icon="mdi-key-variant"
                                    :type="show ? 'text' : 'password'"
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="show = !show"
                                    :rules=rule
                                ></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-spacer></v-spacer>
                            <v-col cols="12">
                            <v-btn 
                                color="primary" 
                                block
                                class="px-5"
                                :loading="loadingBtn"
                                @click="resetPass"
                            >
                                Actualizar contraseña
                            </v-btn>
                            </v-col>
                    </v-card>
                </v-col>
            </v-row>
          </v-container>
    </v-main>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import axios from 'axios'
export default {
    name:'ResetPasswordComponent',
    data : () => ({
        fetching: 'fetching',
        password:'',
        show: false,
        user:'',
        userLoginId:null,
        rule:[
            v => !!v || 'La contraseña es requerida'
        ]
    }),
    computed:{
        ...mapState(['loadingBtn'])
    },
    methods:{

        ...mapMutations(['setLoadingBtn','setUrl']),

        ...mapActions(['loginAction','requestApi','alertNotification']),

        validateToken(token){

            this.setUrl(`user-laboratorio`)
            this.requestApi({
                method:'GET',
                data:{
                    token: token
                }
            })
            .then(res=>{
                console.log(res.status)
                if(res.status==200)
                    this.fetching = 'success'
                    this.user = res.data.detail
                console.log(res)
            }).catch(err=>{
                this.fetching='error'
                console.log(err)
            })
        },

        resetPass(){
            
            if(!this.$refs.form_reset_password.validate())
                return

            this.setUrl('user-laboratorio')
            this.requestApi({
                method:'PATCH',
                data:{
                    data:{
                        password: this.password,
                        cliente_id: this.userLoginId
                    }
                }
            })
            .then(res=>{
                console.log(res)
                if(res.status==200){

                    this.alertNotification({
                        param:{
                            html : res.data.detail
                        }
                    })

                    this.setUrl('oauth')

                    this.loginAction({
                        user : this.userLoginId,
                        password: this.password,
                    }).then(res=>{
                        this.$router.push('/')
                    })

                }
                
            }).catch(err=>{
                
                console.log(err)
            })

        }

    },
    mounted(){
        
        this.userLoginId = this.$route.params.token.split('-')[1]
        this.validateToken(this.$route.params.token)
    }
}
</script>
